import { AuctionCatalogueStatusEnum } from "../_common/enum/auctionCatalogueStatus.enum";
import { API_URL } from "../_config/config.const";
import { getBody } from "../_helpers/body.helper";
import { handleResponse } from "../_helpers/handleResponse.helper";
import { getHeader } from "../_helpers/header.helper";

const API_NAME = "catalogueItem";

export const catalogueItemService = {
    getActive,
    setStatus,
    complete,
    reoffer,
    withdraw
};

function getActive(auctionId: number, proxyBidderId?: string) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/getActive/?auctionId=${auctionId}&userId=${proxyBidderId ?? ""}`, requestOptions).then(handleResponse);
}

function setStatus(id: number, auctionCatalogueStatusId: AuctionCatalogueStatusEnum) {
    const requestOptions = { method: 'PUT', headers: getHeader(), body: getBody({ id: id, auctionCatalogueStatusId: auctionCatalogueStatusId }) };
    return fetch(`${API_URL}/${API_NAME}/setStatus`, requestOptions).then(handleResponse);
}

function complete(catalogueItemId: number, catalogueItemUserBidId: number) {
    const requestOptions = { method: 'POST', headers: getHeader(), body: getBody({ catalogueItemId: catalogueItemId, catalogueItemUserBidId: catalogueItemUserBidId }) };
    return fetch(`${API_URL}/${API_NAME}/complete`, requestOptions).then(handleResponse);
}

function reoffer(catalogueItemId: number, catalogueItemUserBidIds: Array<number>) {
    const requestOptions = { method: 'POST', headers: getHeader(), body: getBody({ catalogueItemId: catalogueItemId, catalogueItemUserBidIds: catalogueItemUserBidIds }) };
    return fetch(`${API_URL}/${API_NAME}/reoffer`, requestOptions).then(handleResponse);
}

function withdraw(catalogueItemId: number) {
    const requestOptions = { method: 'POST', headers: getHeader(), body: getBody({ catalogueItemId: catalogueItemId }) };
    return fetch(`${API_URL}/${API_NAME}/withdraw`, requestOptions).then(handleResponse);
}